{
  "rate": 0.08,
  "note": "Art direction, not measurements. base is linear RGB, the same numbers Blender's Principled Base Color takes. color and absorption are sRGB hex for the translucent jelly look. A variant with css has no rendered thumbnail and uses that filter on the base image. A variant may also carry tear (pull-apart overrides) and bridge ('cut' makes the stretching strands take the cut face's material). A variant may also carry glitter (count, colors, iridescence) for toys with glitter inside. A variant may also carry mood (the hex colour a pressure-reactive toy turns where it is pressed).",
  "variants": {
    "peach": {
      "gold": {
        "materials": {
          "jelly_peach": {
            "base": [
              0.98,
              0.68,
              0.12
            ],
            "color": "#fff1a6",
            "absorption": "#f0a414"
          }
        }
      },
      "white": {
        "materials": {
          "jelly_peach": {
            "base": [
              0.98,
              0.9,
              0.8
            ],
            "color": "#fff8ee",
            "absorption": "#f6dcc0"
          }
        }
      }
    },
    "watermelon": {
      "yellow": {
        "materials": {
          "jelly_watermelon": {
            "base": [
              0.98,
              0.78,
              0.1
            ],
            "color": "#fff39a",
            "absorption": "#e6b31a"
          }
        }
      },
      "blackrind": {
        "materials": {
          "mochi_rind": {
            "base": [
              0.028,
              0.042,
              0.028
            ]
          }
        }
      }
    },
    "strawberry": {
      "white": {
        "materials": {
          "jelly_strawberry": {
            "base": [
              0.98,
              0.92,
              0.88
            ]
          }
        }
      },
      "pink": {
        "materials": {
          "jelly_strawberry": {
            "base": [
              1.0,
              0.451,
              0.565
            ]
          }
        }
      }
    },
    "grape": {
      "muscat": {
        "materials": {
          "jelly_grape": {
            "base": [
              0.56,
              0.86,
              0.28
            ],
            "color": "#eef6b0",
            "absorption": "#8ccf3a"
          }
        }
      },
      "dark": {
        "materials": {
          "jelly_grape": {
            "base": [
              0.068,
              0.017,
              0.133
            ],
            "color": "#9a6ac8",
            "absorption": "#3a0f5a"
          }
        }
      }
    },
    "cherry": {
      "rainier": {
        "materials": {
          "jelly_cherry": {
            "base": [
              0.98,
              0.76,
              0.32
            ]
          }
        }
      },
      "dark": {
        "materials": {
          "jelly_cherry": {
            "base": [
              0.144,
              0.005,
              0.016
            ]
          }
        }
      }
    },
    "tangerine": {
      "green": {
        "materials": {
          "mochi_tangerine": {
            "base": [
              0.6,
              0.8,
              0.1
            ]
          },
          "rind_pore": {
            "base": [
              0.4,
              0.58,
              0.04
            ]
          }
        }
      },
      "blood": {
        "materials": {
          "mochi_tangerine": {
            "base": [
              0.761,
              0.07,
              0.024
            ]
          },
          "rind_pore": {
            "base": [
              0.479,
              0.037,
              0.013
            ]
          }
        }
      }
    },
    "macaron": {
      "strawberry": {
        "materials": {
          "foam_macaron": {
            "base": [
              0.95,
              0.42,
              0.58
            ]
          }
        }
      },
      "lemon": {
        "materials": {
          "foam_macaron": {
            "base": [
              0.98,
              0.84,
              0.26
            ]
          }
        }
      }
    },
    "donut": {
      "matcha": {
        "materials": {
          "icing_berry": {
            "base": [
              0.5,
              0.74,
              0.28
            ]
          }
        }
      },
      "chocolate": {
        "materials": {
          "icing_berry": {
            "base": [
              0.26,
              0.11,
              0.05
            ]
          }
        }
      }
    },
    "pudding": {
      "matcha": {
        "materials": {
          "mochi_custard": {
            "base": [
              0.58,
              0.74,
              0.3
            ]
          }
        }
      },
      "chocolate": {
        "materials": {
          "mochi_custard": {
            "base": [
              0.34,
              0.15,
              0.06
            ]
          }
        }
      }
    },
    "mushroom": {
      "brown": {
        "materials": {
          "mochi_cap": {
            "base": [
              0.46,
              0.26,
              0.12
            ]
          }
        }
      },
      "red": {
        "materials": {
          "mochi_cap": {
            "base": [
              0.761,
              0.06,
              0.042
            ]
          }
        }
      }
    },
    "gyoza": {
      "sakura": {
        "css": "hue-rotate(-28deg) saturate(1.9) brightness(1.04)",
        "materials": {
          "mochi_gyoza": {
            "base": [
              1,
              0.8,
              0.88
            ]
          }
        }
      },
      "matcha": {
        "css": "hue-rotate(58deg) saturate(1.7)",
        "materials": {
          "mochi_gyoza": {
            "base": [
              0.8,
              0.96,
              0.62
            ]
          }
        }
      }
    },
    "dumpling": {
      "sakura": {
        "css": "hue-rotate(-28deg) saturate(1.9) brightness(1.04)",
        "materials": {
          "mochi_dumpling": {
            "base": [
              1,
              0.8,
              0.88
            ]
          }
        }
      },
      "matcha": {
        "css": "hue-rotate(58deg) saturate(1.7)",
        "materials": {
          "mochi_dumpling": {
            "base": [
              0.8,
              0.96,
              0.62
            ]
          }
        }
      }
    },
    "pullmochi": {
      "sakura": {
        "materials": {
          "mochi_pull_dough": {
            "base": [
              1,
              0.6,
              0.74
            ]
          },
          "mochi_pull_cut": {
            "base": [
              1,
              0.8,
              0.86
            ]
          }
        }
      },
      "matcha": {
        "materials": {
          "mochi_pull_dough": {
            "base": [
              0.52,
              0.85,
              0.36
            ]
          },
          "mochi_pull_cut": {
            "base": [
              0.74,
              0.93,
              0.55
            ]
          }
        }
      },
      "cheese": {
        "materials": {
          "mochi_pull_dough": {
            "base": [
              0.92,
              0.5,
              0.06
            ]
          },
          "mochi_pull_cut": {
            "base": [
              1,
              0.58,
              0.0
            ]
          }
        },
        "bridge": "cut",
        "tear": {
          "stretch": 3.4,
          "elastic": 0.12,
          "gravity": 1.3,
          "lobe": 0.05,
          "thin": 4.2
        }
      }
    },
    "waxball": {
      "rainbow": {
        "css": "saturate(1.4)",
        "materials": {
          "wax_ball_marble": {
            "base": [
              1,
              1,
              1
            ]
          },
          "clay_ball_core": {
            "base": [
              1,
              0.97,
              0.97
            ]
          }
        }
      },
      "lemon": {
        "css": "hue-rotate(38deg) saturate(1.3)",
        "materials": {
          "wax_ball_marble": {
            "base": [
              1,
              0.95,
              0.62
            ]
          },
          "clay_ball_core": {
            "base": [
              1,
              0.92,
              0.52
            ]
          }
        }
      },
      "mint": {
        "css": "hue-rotate(-70deg) saturate(1.2)",
        "materials": {
          "wax_ball_marble": {
            "base": [
              0.72,
              1,
              0.86
            ]
          },
          "clay_ball_core": {
            "base": [
              0.74,
              0.97,
              0.86
            ]
          }
        }
      }
    },
    "steambun": {
      "gold": {
        "css": "sepia(.45) saturate(1.6) brightness(1.03)",
        "materials": {
          "jelly_bun_milk": {
            "base": [
              1,
              0.93,
              0.78
            ],
            "color": "#fff1d6",
            "absorption": "#e7c38a"
          }
        },
        "glitter": {
          "count": 150,
          "colors": [
            "#ffd76a",
            "#ffe9a8",
            "#f4b93c"
          ]
        }
      },
      "holo": {
        "css": "hue-rotate(200deg) saturate(1.3)",
        "materials": {
          "jelly_bun_milk": {
            "base": [
              0.95,
              0.95,
              1
            ],
            "color": "#f3f2ff",
            "absorption": "#cfd2f5"
          }
        },
        "glitter": {
          "count": 150,
          "colors": [
            "#ffffff",
            "#e8f4ff",
            "#ffe8fb"
          ],
          "iridescence": 1
        }
      },
      "galaxy": {
        "css": "hue-rotate(220deg) saturate(2) brightness(.7)",
        "materials": {
          "jelly_bun_milk": {
            "base": [
              0.2,
              0.22,
              0.5
            ],
            "color": "#565ab8",
            "absorption": "#24276e"
          }
        },
        "glitter": {
          "count": 170,
          "colors": [
            "#ffffff",
            "#bcd7ff",
            "#f6d2ff"
          ]
        }
      }
    },
    "moodmallow": {
      "lemon": {
        "css": "hue-rotate(68deg) saturate(1.5) brightness(1.06)",
        "materials": {
          "foam_moodmallow": {
            "base": [
              0.99,
              0.86,
              0.38
            ]
          }
        },
        "mood": "#ff8a3d"
      },
      "sky": {
        "css": "hue-rotate(-128deg) saturate(1.3)",
        "materials": {
          "foam_moodmallow": {
            "base": [
              0.58,
              0.8,
              0.99
            ]
          }
        },
        "mood": "#ff74c4"
      }
    },
    "peelmikan": {
      "pink": {
        "css": "none",
        "materials": {
          "jelly_mikan": {
            "color": "#ff9cb8",
            "absorption": "#ff4f86",
            "base": [
              0.99,
              0.55,
              0.66
            ]
          }
        }
      },
      "lemon": {
        "css": "none",
        "materials": {
          "jelly_mikan": {
            "color": "#ffe36b",
            "absorption": "#f2b705",
            "base": [
              0.99,
              0.88,
              0.36
            ]
          }
        }
      }
    },
    "bunny": {
      "sakura": {
        "materials": {
          "mochi_milk": {
            "base": [
              1.0,
              0.708,
              0.791
            ]
          }
        }
      },
      "lavender": {
        "materials": {
          "mochi_milk": {
            "base": [
              0.807,
              0.738,
              1.0
            ]
          }
        }
      }
    },
    "bear": {
      "polar": {
        "materials": {
          "foam_bread": {
            "base": [
              0.913,
              0.863,
              0.776
            ]
          },
          "foam_toast": {
            "base": [
              0.694,
              0.578,
              0.456
            ]
          }
        }
      },
      "honey": {
        "materials": {
          "foam_bread": {
            "base": [
              0.815,
              0.392,
              0.04
            ]
          },
          "foam_toast": {
            "base": [
              0.479,
              0.156,
              0.012
            ]
          }
        }
      }
    },
    "egg": {
      "sakura": {
        "materials": {
          "wax_mint": {
            "base": [
              0.922,
              0.485,
              0.597
            ]
          },
          "jelly_core": {
            "base": [
              1.0,
              0.644,
              0.102
            ]
          }
        }
      },
      "night": {
        "materials": {
          "wax_mint": {
            "base": [
              0.061,
              0.08,
              0.275
            ]
          },
          "jelly_core": {
            "base": [
              1.0,
              0.644,
              0.102
            ]
          }
        }
      }
    },
    "star": {
      "gold": {
        "materials": {
          "jelly_lavender": {
            "base": [
              1.0,
              0.658,
              0.107
            ]
          }
        }
      },
      "mint": {
        "materials": {
          "jelly_lavender": {
            "base": [
              0.275,
              0.791,
              0.597
            ]
          }
        }
      }
    },
    "seal": {
      "grey": {
        "materials": {
          "mochi_milk": {
            "base": [
              0.624,
              0.658,
              0.716
            ]
          },
          "cream": {
            "base": [
              0.807,
              0.716,
              0.597
            ]
          }
        }
      },
      "pink": {
        "materials": {
          "mochi_milk": {
            "base": [
              1.0,
              0.68,
              0.768
            ]
          }
        }
      }
    },
    "chick": {
      "white": {
        "materials": {
          "mochi_chick": {
            "base": [
              1.0,
              0.896,
              0.738
            ]
          }
        }
      },
      "pink": {
        "materials": {
          "mochi_chick": {
            "base": [
              1.0,
              0.546,
              0.658
            ]
          }
        }
      }
    },
    "toast": {
      "jam": {
        "materials": {
          "butter": {
            "base": [
              0.687,
              0.034,
              0.072
            ]
          }
        }
      },
      "caramel": {
        "materials": {
          "foam_crust": {
            "base": [
              0.195,
              0.036,
              0.005
            ]
          },
          "butter": {
            "base": [
              0.761,
              0.361,
              0.068
            ]
          }
        }
      }
    },
    "cloud": {
      "sunset": {
        "materials": {
          "mochi_cloud": {
            "base": [
              1.0,
              0.584,
              0.462
            ]
          }
        }
      },
      "night": {
        "materials": {
          "mochi_cloud": {
            "base": [
              0.474,
              0.456,
              1.0
            ]
          }
        }
      }
    },
    "cat": {
      "black": {
        "materials": {
          "mochi_cat": {
            "base": [
              0.07,
              0.061,
              0.084
            ]
          },
          "ear_rose": {
            "base": [
              0.571,
              0.195,
              0.262
            ]
          },
          "cream": {
            "base": [
              0.254,
              0.223,
              0.287
            ]
          }
        }
      },
      "white": {
        "materials": {
          "mochi_cat": {
            "base": [
              0.965,
              0.93,
              0.888
            ]
          },
          "ear_rose": {
            "base": [
              0.888,
              0.381,
              0.468
            ]
          },
          "cream": {
            "base": [
              1.0,
              0.896,
              0.823
            ]
          }
        }
      }
    },
    "paw": {
      "black": {
        "materials": {
          "mochi_paw": {
            "base": [
              0.074,
              0.065,
              0.091
            ]
          },
          "paw_rose": {
            "base": [
              1.0,
              0.332,
              0.456
            ]
          }
        }
      },
      "mint": {
        "materials": {
          "mochi_paw": {
            "base": [
              0.61,
              0.896,
              0.761
            ]
          }
        }
      }
    },
    "cube": {
      "lemon": {
        "materials": {
          "clay_rose": {
            "base": [
              1.0,
              0.745,
              0.195
            ]
          }
        }
      },
      "sky": {
        "materials": {
          "clay_rose": {
            "base": [
              0.342,
              0.631,
              1.0
            ]
          }
        }
      }
    },
    "heart": {
      "gold": {
        "materials": {
          "jelly_heart": {
            "base": [
              1.0,
              0.68,
              0.144
            ],
            "color": "#fff0b0",
            "absorption": "#e2a21e"
          }
        }
      },
      "lilac": {
        "materials": {
          "jelly_heart": {
            "base": [
              0.584,
              0.361,
              1.0
            ],
            "color": "#eadcff",
            "absorption": "#9a5cff"
          }
        }
      }
    },
    "bubbletea": {
      "matcha": {
        "materials": {
          "mochi_milk_tea": {
            "base": [
              0.292,
              0.491,
              0.122
            ]
          },
          "straw_rose": {
            "base": [
              0.888,
              0.584,
              0.072
            ]
          }
        }
      },
      "taro": {
        "materials": {
          "mochi_milk_tea": {
            "base": [
              0.456,
              0.323,
              0.672
            ]
          },
          "straw_rose": {
            "base": [
              0.212,
              0.571,
              0.694
            ]
          }
        }
      }
    },
    "banana": {
      "green": {
        "materials": {
          "foam_banana": {
            "base": [
              0.485,
              0.672,
              0.107
            ]
          }
        }
      },
      "pink": {
        "materials": {
          "foam_banana": {
            "base": [
              1.0,
              0.456,
              0.584
            ]
          }
        }
      }
    },
    "flower": {
      "sky": {
        "materials": {
          "mochi_petal": {
            "base": [
              0.485,
              0.68,
              1.0
            ]
          },
          "mochi_flower_center": {
            "base": [
              1.0,
              0.745,
              0.195
            ]
          }
        }
      },
      "sunflower": {
        "materials": {
          "mochi_petal": {
            "base": [
              1.0,
              0.687,
              0.078
            ]
          },
          "mochi_flower_center": {
            "base": [
              0.254,
              0.102,
              0.024
            ]
          }
        }
      }
    },
    "pancake": {
      "berry": {
        "materials": {
          "syrup": {
            "base": [
              0.434,
              0.01,
              0.05
            ]
          }
        }
      },
      "chocolate": {
        "materials": {
          "syrup": {
            "base": [
              0.047,
              0.01,
              0.003
            ]
          }
        }
      }
    },
    "soap": {
      "rose": {
        "materials": {
          "jelly_soap": {
            "base": [
              1.0,
              0.347,
              0.539
            ]
          },
          "soap_stamp": {
            "base": [
              1.0,
              0.631,
              0.745
            ]
          }
        }
      },
      "lemon": {
        "materials": {
          "jelly_soap": {
            "base": [
              1.0,
              0.776,
              0.156
            ]
          },
          "soap_stamp": {
            "base": [
              1.0,
              0.896,
              0.462
            ]
          }
        }
      }
    },
    "crunchball": {
      "strawberry": {
        "materials": {
          "bead_lilac": {
            "base": [
              1.0,
              0.275,
              0.434
            ]
          },
          "bead_mint": {
            "base": [
              1.0,
              0.539,
              0.651
            ]
          },
          "bead_peach": {
            "base": [
              1.0,
              0.159,
              0.275
            ]
          },
          "bead_cream": {
            "base": [
              1.0,
              0.871,
              0.905
            ]
          }
        }
      },
      "ocean": {
        "materials": {
          "bead_lilac": {
            "base": [
              0.102,
              0.361,
              1.0
            ]
          },
          "bead_mint": {
            "base": [
              0.212,
              0.745,
              0.791
            ]
          },
          "bead_peach": {
            "base": [
              0.028,
              0.159,
              0.687
            ]
          },
          "bead_cream": {
            "base": [
              0.687,
              0.905,
              1.0
            ]
          }
        }
      }
    },
    "meshball": {
      "grape": {
        "materials": {
          "mesh_gel_lime": {
            "base": [
              0.328,
              0.109,
              0.784
            ]
          }
        }
      },
      "peach": {
        "materials": {
          "mesh_gel_lime": {
            "base": [
              1.0,
              0.342,
              0.205
            ]
          }
        }
      }
    },
    "slimeblob": {
      "lemon": {
        "materials": {
          "slime_aqua": {
            "base": [
              0.888,
              0.708,
              0.091
            ]
          }
        }
      },
      "berry": {
        "materials": {
          "slime_aqua": {
            "base": [
              0.768,
              0.109,
              0.342
            ]
          }
        }
      }
    },
    "pouchcream": {
      "sakura": {
        "css": "hue-rotate(-40deg) saturate(.8) brightness(1.15)",
        "materials": {
          "filling_bread_cream": {
            "filter": "hue-rotate(-40deg) saturate(.8) brightness(1.15)"
          },
          "sesame_cream": {
            "base": [
              1.0,
              0.558,
              0.665
            ]
          }
        }
      },
      "matcha": {
        "css": "hue-rotate(75deg) saturate(.85)",
        "materials": {
          "filling_bread_cream": {
            "filter": "hue-rotate(75deg) saturate(.85)"
          },
          "sesame_cream": {
            "base": [
              0.397,
              0.624,
              0.258
            ]
          }
        }
      }
    },
    "pouchmochi": {
      "matcha": {
        "materials": {
          "filling_water_mochi": {
            "base": [
              0.468,
              0.708,
              0.27
            ]
          }
        }
      },
      "yuzu": {
        "materials": {
          "filling_water_mochi": {
            "base": [
              1.0,
              0.753,
              0.195
            ]
          }
        }
      }
    },
    "amberjelly": {
      "emerald": {
        "materials": {
          "jelly_amber_honey": {
            "base": [
              0.078,
              0.521,
              0.238
            ]
          }
        }
      },
      "ruby": {
        "materials": {
          "jelly_amber_honey": {
            "base": [
              0.694,
              0.044,
              0.105
            ]
          }
        }
      }
    },
    "waterdrop": {
      "sky": {
        "materials": {
          "jelly_water_clear": {
            "base": [
              0.521,
              0.784,
              1.0
            ]
          }
        }
      },
      "soda": {
        "materials": {
          "jelly_water_clear": {
            "base": [
              0.521,
              0.888,
              0.624
            ]
          }
        }
      }
    },
    "strawberrycake": {
      "chocolate": {
        "materials": {
          "foam_cake_cream": {
            "base": [
              0.262,
              0.105,
              0.047
            ]
          },
          "foam_strawberry_jam": {
            "base": [
              0.068,
              0.018,
              0.006
            ]
          }
        }
      },
      "matcha": {
        "materials": {
          "foam_cake_cream": {
            "base": [
              0.468,
              0.658,
              0.254
            ]
          },
          "foam_strawberry_jam": {
            "base": [
              0.147,
              0.275,
              0.025
            ]
          }
        }
      }
    },
    "pouchcustard": {
      "strawberry": {
        "css": "hue-rotate(-45deg) saturate(1.1)",
        "materials": {
          "filling_custard": {
            "filter": "hue-rotate(-45deg) saturate(1.1)"
          }
        }
      },
      "chocolate": {
        "css": "sepia(.6) saturate(1.2) brightness(.78)",
        "materials": {
          "filling_custard": {
            "filter": "sepia(.6) saturate(1.2) brightness(.78)"
          }
        }
      }
    },
    "warabimochi": {
      "matcha": {
        "css": "hue-rotate(70deg) saturate(.6) brightness(1.05)",
        "materials": {
          "slime_warabi_brown": {
            "filter": "hue-rotate(70deg) saturate(.6) brightness(1.05)"
          },
          "kinako_powder": {
            "base": [
              0.275,
              0.521,
              0.102
            ]
          }
        }
      },
      "sakura": {
        "css": "hue-rotate(-35deg) saturate(.75) brightness(1.35)",
        "materials": {
          "slime_warabi_brown": {
            "filter": "hue-rotate(-35deg) saturate(.75) brightness(1.35)"
          },
          "kinako_powder": {
            "base": [
              0.913,
              0.445,
              0.558
            ]
          }
        }
      }
    },
    "fruitjelly": {
      "soda": {
        "materials": {
          "jelly_fruit_clear": {
            "base": [
              0.521,
              0.791,
              1.0
            ]
          }
        }
      },
      "peach": {
        "materials": {
          "jelly_fruit_clear": {
            "base": [
              1.0,
              0.665,
              0.552
            ]
          }
        }
      }
    },
    "gelbeads": {
      "pastel": {
        "materials": {
          "gelbead_ruby": {
            "base": [
              1.0,
              0.347,
              0.434
            ]
          },
          "gelbead_aqua": {
            "base": [
              0.347,
              0.631,
              1.0
            ]
          },
          "gelbead_lime": {
            "base": [
              0.485,
              0.871,
              0.254
            ]
          },
          "gelbead_violet": {
            "base": [
              0.584,
              0.392,
              1.0
            ]
          },
          "gelbead_gold": {
            "base": [
              1.0,
              0.651,
              0.254
            ]
          },
          "gelbead_turquoise": {
            "base": [
              0.347,
              0.807,
              0.716
            ]
          }
        }
      },
      "gold": {
        "materials": {
          "gelbead_ruby": {
            "base": [
              1.0,
              0.624,
              0.068
            ]
          },
          "gelbead_aqua": {
            "base": [
              1.0,
              0.434,
              0.027
            ]
          },
          "gelbead_lime": {
            "base": [
              1.0,
              0.745,
              0.254
            ]
          },
          "gelbead_violet": {
            "base": [
              0.888,
              0.376,
              0.013
            ]
          },
          "gelbead_gold": {
            "base": [
              1.0,
              0.694,
              0.133
            ]
          },
          "gelbead_turquoise": {
            "base": [
              0.807,
              0.479,
              0.07
            ]
          }
        }
      }
    },
    "waxmallow": {
      "grape": {
        "materials": {
          "jelly_wax_orange": {
            "base": [
              0.262,
              0.078,
              0.701
            ]
          },
          "wax_cream_sheet": {
            "base": [
              0.831,
              0.738,
              1.0
            ]
          }
        }
      },
      "melon": {
        "materials": {
          "jelly_wax_orange": {
            "base": [
              0.159,
              0.624,
              0.156
            ]
          },
          "wax_cream_sheet": {
            "base": [
              0.745,
              0.922,
              0.776
            ]
          }
        }
      }
    },
    "candyberry": {
      "blueberry": {
        "materials": {
          "candy_shell_glass": {
            "base": [
              0.017,
              0.03,
              0.209
            ]
          },
          "mochi_berry_core": {
            "base": [
              0.205,
              0.262,
              1.0
            ]
          }
        }
      },
      "gold": {
        "materials": {
          "candy_shell_glass": {
            "base": [
              0.434,
              0.144,
              0.0
            ]
          },
          "mochi_berry_core": {
            "base": [
              1.0,
              0.658,
              0.102
            ]
          }
        }
      }
    },
    "melonpan": {
      "strawberry": {
        "css": "hue-rotate(-40deg) saturate(1.15) brightness(1.04)",
        "materials": {
          "crust_melon": {
            "filter": "hue-rotate(-40deg) saturate(1.15) brightness(1.04)"
          },
          "mochi_melon_core": {
            "base": [
              1.0,
              0.44,
              0.558
            ]
          },
          "melon_net": {
            "base": [
              1.0,
              0.694,
              0.768
            ]
          }
        }
      },
      "chocolate": {
        "css": "sepia(1) saturate(1.5) hue-rotate(-12deg) brightness(.55)",
        "materials": {
          "crust_melon": {
            "filter": "sepia(1) saturate(1.5) hue-rotate(-12deg) brightness(.55)"
          },
          "mochi_melon_core": {
            "base": [
              0.27,
              0.112,
              0.051
            ]
          },
          "melon_net": {
            "base": [
              0.578,
              0.352,
              0.202
            ]
          }
        }
      }
    },
    "chocobar": {
      "white": {
        "materials": {
          "wax_chocolate": {
            "base": [
              0.888,
              0.807,
              0.672
            ]
          },
          "mochi_chocolate_core": {
            "base": [
              1.0,
              0.68,
              0.381
            ]
          }
        }
      },
      "strawberry": {
        "materials": {
          "wax_chocolate": {
            "base": [
              0.807,
              0.25,
              0.352
            ]
          },
          "mochi_chocolate_core": {
            "base": [
              0.479,
              0.061,
              0.12
            ]
          }
        }
      }
    },
    "goldfishjelly": {
      "black": {
        "materials": {
          "fish_goldfish": {
            "base": [
              0.026,
              0.022,
              0.032
            ]
          },
          "fish_fin": {
            "base": [
              0.068,
              0.06,
              0.084
            ]
          }
        }
      },
      "white": {
        "materials": {
          "fish_goldfish": {
            "base": [
              1.0,
              0.93,
              0.871
            ]
          },
          "fish_fin": {
            "base": [
              1.0,
              0.254,
              0.147
            ]
          }
        }
      }
    },
    "panda": {
      "pink": {
        "materials": {
          "plush_charcoal": {
            "base": [
              0.871,
              0.352,
              0.479
            ]
          },
          "plush_inner_ear": {
            "base": [
              0.694,
              0.195,
              0.301
            ]
          }
        }
      },
      "brown": {
        "materials": {
          "plush_charcoal": {
            "base": [
              0.195,
              0.07,
              0.025
            ]
          },
          "plush_inner_ear": {
            "base": [
              0.102,
              0.034,
              0.014
            ]
          }
        }
      }
    },
    "pandamochi": {
      "brown": {
        "materials": {
          "mochi_panda_ink": {
            "base": [
              0.195,
              0.07,
              0.025
            ]
          }
        }
      },
      "pink": {
        "materials": {
          "mochi_panda_ink": {
            "base": [
              0.871,
              0.254,
              0.392
            ]
          }
        }
      }
    },
    "cheesepizza": {
      "cheddar": {
        "css": "sepia(.3) saturate(1.8) brightness(1.02)",
        "materials": {
          "pizza_melted_mozzarella": {
            "filter": "sepia(.3) saturate(1.8) brightness(1.02)"
          }
        }
      },
      "pesto": {
        "css": "hue-rotate(20deg) saturate(.75) brightness(1.05)",
        "materials": {
          "pizza_tomato_sauce": {
            "base": [
              0.105,
              0.254,
              0.025
            ]
          },
          "pizza_melted_mozzarella": {
            "filter": "hue-rotate(20deg) saturate(.75) brightness(1.05)"
          }
        }
      }
    },
    "auroragel": {
      "sunset": {
        "css": "hue-rotate(130deg) saturate(1.1)",
        "materials": {
          "aurora_gel": {
            "filter": "hue-rotate(130deg) saturate(1.1)"
          }
        }
      },
      "night": {
        "css": "hue-rotate(40deg) brightness(.85) saturate(1.3)",
        "materials": {
          "aurora_gel": {
            "filter": "hue-rotate(40deg) brightness(.85) saturate(1.3)"
          }
        }
      }
    },
    "butterstick": {
      "strawberry": {
        "materials": {
          "foam_butter": {
            "base": [
              1.0,
              0.445,
              0.552
            ]
          }
        }
      },
      "gold": {
        "materials": {
          "foil_wrap": {
            "base": [
              0.768,
              0.509,
              0.078
            ]
          }
        }
      }
    },
    "sugarcube": {
      "pink": {
        "materials": {
          "jelly_sugar": {
            "base": [
              1.0,
              0.527,
              0.672
            ],
            "color": "#ffe0ea",
            "absorption": "#ff6f9e"
          }
        }
      },
      "blue": {
        "materials": {
          "jelly_sugar": {
            "base": [
              0.503,
              0.694,
              1.0
            ],
            "color": "#e0efff",
            "absorption": "#5a9cff"
          }
        }
      }
    },
    "konamochi": {
      "matcha": {
        "materials": {
          "mochi_kona": {
            "base": [
              0.332,
              0.552,
              0.147
            ]
          }
        }
      },
      "kinako": {
        "materials": {
          "mochi_kona": {
            "base": [
              0.761,
              0.456,
              0.147
            ]
          }
        }
      }
    },
    "fluffydog": {
      "chocolate": {
        "materials": {
          "plush_fur": {
            "base": [
              0.328,
              0.147,
              0.067
            ]
          }
        }
      },
      "black": {
        "materials": {
          "plush_fur": {
            "base": [
              0.07,
              0.061,
              0.082
            ]
          }
        }
      }
    },
    "magnetputty": {
      "gold": {
        "css": "sepia(.5) saturate(1.6) brightness(1.05)",
        "materials": {
          "magnetic_putty": {
            "filter": "sepia(.5) saturate(1.6) brightness(1.05)"
          }
        }
      },
      "rose": {
        "css": "hue-rotate(-40deg) saturate(1.2)",
        "materials": {
          "magnetic_putty": {
            "filter": "hue-rotate(-40deg) saturate(1.2)"
          }
        }
      }
    },
    "popcloud": {
      "sunset": {
        "materials": {
          "silicone_popcloud": {
            "base": [
              1.0,
              0.347,
              0.485
            ]
          },
          "silicone_dome_mint": {
            "base": [
              1.0,
              0.638,
              0.254
            ]
          },
          "silicone_dome_butter": {
            "base": [
              1.0,
              0.451,
              0.254
            ]
          },
          "silicone_dome_peach": {
            "base": [
              1.0,
              0.254,
              0.392
            ]
          }
        }
      },
      "ocean": {
        "materials": {
          "silicone_popcloud": {
            "base": [
              0.159,
              0.468,
              1.0
            ]
          },
          "silicone_dome_mint": {
            "base": [
              0.347,
              0.871,
              0.745
            ]
          },
          "silicone_dome_butter": {
            "base": [
              0.578,
              0.791,
              1.0
            ]
          },
          "silicone_dome_peach": {
            "base": [
              0.212,
              0.631,
              1.0
            ]
          }
        }
      }
    },
    "surpriseegg": {
      "pink": {
        "css": "none",
        "materials": {
          "chick_down": {
            "base": [
              1.0,
              0.451,
              0.578
            ]
          }
        }
      },
      "blue": {
        "css": "none",
        "materials": {
          "chick_down": {
            "base": [
              0.347,
              0.631,
              1.0
            ]
          }
        }
      }
    },
    "watersnake": {
      "gold": {
        "materials": {
          "float_fish": {
            "base": [
              1.0,
              0.624,
              0.05
            ]
          },
          "float_star": {
            "base": [
              1.0,
              0.88,
              0.392
            ]
          }
        }
      },
      "pink": {
        "materials": {
          "float_fish": {
            "base": [
              1.0,
              0.275,
              0.468
            ]
          },
          "float_star": {
            "base": [
              1.0,
              0.631,
              0.745
            ]
          }
        }
      }
    },
    "rollcake": {
      "chocolate": {
        "css": "sepia(1) saturate(1.6) hue-rotate(-15deg) brightness(.5)",
        "materials": {
          "foam_rollcake_sponge": {
            "filter": "sepia(1) saturate(1.6) hue-rotate(-15deg) brightness(.5)"
          },
          "foam_rollcake_cut": {
            "filter": "sepia(1) saturate(1.6) hue-rotate(-15deg) brightness(.5)"
          }
        }
      },
      "strawberry": {
        "css": "hue-rotate(-30deg) saturate(1.2)",
        "materials": {
          "foam_rollcake_sponge": {
            "filter": "hue-rotate(-30deg) saturate(1.2)"
          },
          "foam_rollcake_cut": {
            "filter": "hue-rotate(-30deg) saturate(1.2)"
          }
        }
      }
    },
    "splatocto": {
      "blue": {
        "materials": {
          "jelly_octopus": {
            "base": [
              0.275,
              0.521,
              1.0
            ],
            "color": "#d6e8ff",
            "absorption": "#4f8fff"
          }
        }
      },
      "gold": {
        "materials": {
          "jelly_octopus": {
            "base": [
              1.0,
              0.631,
              0.144
            ],
            "color": "#fff0b8",
            "absorption": "#e0a020"
          }
        }
      }
    },
    "snowglobe": {
      "polar": {
        "materials": {
          "bear_fur": {
            "base": [
              0.896,
              0.855,
              0.791
            ]
          }
        }
      },
      "sakura": {
        "materials": {
          "foam_globe_base": {
            "base": [
              1.0,
              0.485,
              0.61
            ]
          }
        }
      }
    },
    "waxlamp": {
      "mint": {
        "materials": {
          "foam_lamp_base": {
            "base": [
              0.275,
              0.716,
              0.552
            ]
          },
          "foam_lamp_cap": {
            "base": [
              0.275,
              0.716,
              0.552
            ]
          }
        }
      },
      "night": {
        "materials": {
          "foam_lamp_base": {
            "base": [
              0.063,
              0.065,
              0.262
            ]
          },
          "foam_lamp_cap": {
            "base": [
              0.063,
              0.065,
              0.262
            ]
          }
        }
      }
    },
    "yolkegg": {
      "rich": {
        "materials": {
          "jelly_egg_yolk": {
            "base": [
              1.0,
              0.144,
              0.01
            ],
            "color": "#ffb080",
            "absorption": "#e04a00"
          }
        }
      },
      "lemon": {
        "materials": {
          "jelly_egg_yolk": {
            "base": [
              1.0,
              0.687,
              0.068
            ],
            "color": "#fff0a0",
            "absorption": "#e8b800"
          }
        }
      }
    },
    "squirtduck": {
      "pink": {
        "materials": {
          "mochi_duck": {
            "base": [
              1.0,
              0.445,
              0.571
            ]
          }
        }
      },
      "gold": {
        "materials": {
          "mochi_duck": {
            "base": [
              0.888,
              0.462,
              0.025
            ]
          },
          "duck_beak": {
            "base": [
              0.745,
              0.095,
              0.01
            ]
          }
        }
      }
    },
    "honeytoast": {
      "cocoa": {
        "css": "sepia(.4) saturate(1.05) brightness(.72)",
        "materials": {
          "foam_honeytoast": {
            "filter": "sepia(.4) saturate(1.05) brightness(.72)"
          }
        }
      },
      "matcha": {
        "css": "hue-rotate(50deg) saturate(.8) brightness(1.06)",
        "materials": {
          "foam_honeytoast": {
            "filter": "hue-rotate(50deg) saturate(.8) brightness(1.06)"
          }
        }
      }
    },
    "yakimochi": {
      "yomogi": {
        "materials": {
          "mochi_yaki": {
            "base": [
              0.397,
              0.584,
              0.258
            ]
          }
        }
      },
      "sakura": {
        "materials": {
          "mochi_yaki": {
            "base": [
              1.0,
              0.631,
              0.716
            ]
          }
        }
      }
    },
    "treasurejelly": {
      "lemon": {
        "materials": {
          "jelly_treasure": {
            "base": [
              1.0,
              0.871,
              0.418
            ]
          },
          "dish_treasure": {
            "base": [
              1.0,
              0.768,
              0.323
            ]
          }
        }
      },
      "sakura": {
        "materials": {
          "jelly_treasure": {
            "base": [
              1.0,
              0.651,
              0.761
            ]
          },
          "dish_treasure": {
            "base": [
              1.0,
              0.527,
              0.651
            ]
          }
        }
      }
    },
    "fizzball": {
      "gold": {
        "css": "none",
        "materials": {
          "mochi_mascot_bunny": {
            "base": [
              1.0,
              0.687,
              0.144
            ]
          },
          "mochi_mascot_penguin": {
            "base": [
              0.584,
              0.305,
              0.023
            ]
          },
          "mochi_mascot_seal": {
            "base": [
              1.0,
              0.768,
              0.323
            ]
          }
        }
      },
      "pastel": {
        "css": "none",
        "materials": {
          "mochi_mascot_bunny": {
            "base": [
              1.0,
              0.584,
              0.73
            ]
          },
          "mochi_mascot_penguin": {
            "base": [
              0.275,
              0.479,
              1.0
            ]
          },
          "mochi_mascot_seal": {
            "base": [
              0.584,
              0.871,
              0.745
            ]
          }
        }
      }
    },
    "waterballoon": {
      "pink": {
        "materials": {
          "jelly_balloon": {
            "base": [
              1.0,
              0.342,
              0.539
            ]
          }
        }
      },
      "lemon": {
        "materials": {
          "jelly_balloon": {
            "base": [
              1.0,
              0.761,
              0.15
            ]
          }
        }
      }
    },
    "treatpumpkin": {
      "white": {
        "materials": {
          "candy_pumpkin_shell": {
            "base": [
              0.8,
              0.76,
              0.64
            ]
          }
        }
      },
      "green": {
        "materials": {
          "candy_pumpkin_shell": {
            "base": [
              0.17,
              0.4,
              0.05
            ]
          }
        }
      },
      "gold": {
        "materials": {
          "candy_pumpkin_shell": {
            "base": [
              1.0,
              0.5,
              0.0
            ]
          }
        }
      }
    },
    "cracklebat": {
      "white": {
        "materials": {
          "candy_bat_shell": {
            "base": [
              0.78,
              0.76,
              0.84
            ]
          }
        }
      },
      "pink": {
        "materials": {
          "candy_bat_shell": {
            "base": [
              0.95,
              0.28,
              0.52
            ]
          }
        }
      },
      "mint": {
        "materials": {
          "candy_bat_shell": {
            "base": [
              0.22,
              0.7,
              0.55
            ]
          }
        }
      }
    },
    "frostmochi": {
      "matcha": {
        "materials": {
          "mochi_frost": {
            "base": [
              0.3,
              0.52,
              0.14
            ]
          }
        }
      },
      "lavender": {
        "materials": {
          "mochi_frost": {
            "base": [
              0.52,
              0.33,
              0.86
            ]
          }
        }
      }
    }
  }
}
